import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { hexToHsl, absUrl } from "@/lib/helpers";

const StoreContext = createContext(null);

export const useStore = () => useContext(StoreContext);

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyTheme = useCallback((s) => {
    if (!s) return;
    const hsl = hexToHsl(s.primary_color);
    if (hsl) {
      document.documentElement.style.setProperty("--primary", hsl);
      document.documentElement.style.setProperty("--ring", hsl);
    }
    const acc = hexToHsl(s.accent_color);
    if (acc) document.documentElement.style.setProperty("--accent", acc);
    if (s.seo_title) document.title = s.seo_title;
    if (s.favicon_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = absUrl(s.favicon_url);
    }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      applyTheme(data);
    } catch (e) {
      console.error("gagal memuat pengaturan", e);
    } finally {
      setLoading(false);
    }
  }, [applyTheme]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <StoreContext.Provider value={{ settings, loading, refresh }}>
      {children}
    </StoreContext.Provider>
  );
}
